// Café 1715 — auto-soumission du tri de la grille collection (sans JS inline, CSP-safe).
document.querySelectorAll('[data-cafe-sort]').forEach((sel) => {
  sel.addEventListener('change', () => {
    if (sel.form) sel.form.submit();
  });
});
